import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/author/_author/proceeding/_proceeding')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.proceedings' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
